// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_featured-collection.scss';

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--featured-collection").each(function(index, element){
    var $this = $(this);

    // Generate unique class for each feature collection slider
    $this.addClass("featured-collection-instance-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.featured-collection').find(".swiper-button-prev").addClass("featured-collection-btn-prev-" + index);
    $this.parents('.featured-collection').find(".swiper-button-next").addClass("featured-collection-btn-next-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.featured-collection').find(".swiper-scrollbar").addClass("featured-collection-swiper-scrollbar-" + index);

    // Initialize feature collection slider based on the unique classes generated above.
    var swiper = new Swiper(".featured-collection-instance-" + index, {
        // Optional parameters
        modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
        slidesPerView: 2.5,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

        breakpoints: {
          // when window width is >= 680px
          680: {
            slidesPerView: 5,
            spaceBetween: 20
          }
        },

        // // Navigation arrows
        navigation: {
          nextEl: ".featured-collection-btn-next-" + index,
          prevEl: ".featured-collection-btn-prev-" + index
        },

        // Scrollbar
        scrollbar: {
          el: ".featured-collection-swiper-scrollbar-" + index,
          draggable: true,
        }
    });

    swiper.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
  });
});
